/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type Role = (typeof Role)[keyof typeof Role];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Role = {
  Admin: "Admin",
  Cliente: "Cliente",
  Tecnico: "Tecnico",
  Laboratorio: "Laboratorio",
  Commerciale: "Commerciale",
  AreaManager: "AreaManager",
  Service: "Service",
} as const;
